export const API_URL: string = process.env.REACT_APP_API_URL || 'https://api.getnovala.com';

export const ROLE_SEED: ReadonlyArray<string> = [
  'Manager', 'Supervisor', 'Administrator', 'Office Administrator',
  'Accountant', 'Bookkeeper', 'Receptionist', 'Sales Representative',
  'Customer Service Representative', 'Driver', 'Technician', 'Cleaner',
  'Cook', 'Cashier', 'Labourer', 'Caregiver',
];

export const SETUP_TASKS: ReadonlyArray<string> = [
  'Personal details and address',
  'SIN and tax forms (TD1)',
  'Direct deposit banking',
  'Emergency contact',
];